export default {
  REGISTER_SUCCESS: 'You&rsquo;ve been successfully registered. Click <a href="/">here</a> to see the latest news.',
  REGISTER_FAIL: 'Registration failed. Please try again',
  REGISTER_HINT: 'Don\'t have an account?',
  UPDATE_PROFILE_SUCCESS: 'Your account&rsquo;s been successfully updated. Click <a href="/">here</a> to see the latest news.',
  UPDATE_PROFILE_FAIL: 'Updating account failed. Please try again',
  FORGOT_PASSWORD_HINT: 'Forgot your password?',
  ERROR_MSG: 'Errors occured. Please try again',
  REQUEST_PASSWORD_RESET_SUCCESS: 'An email has been sent to you.',
  REQUEST_PASSWORD_RESET_BUTTON: 'send mail',
  RESET_PASSWORD_BUTTON: 'reset password',
  RESET_PASSWORD_SUCCESS: 'Your password has been reset. Please login again.',
  RESET_PASSWORD_FAIL: 'Reset password failed. Please try again',
  TRY_AGAIN: 'Click here to try again',
  SUBSCRIBE_SUCCESS_TITLE: 'YOU\'RE ALL SET',
  SUBSCRIBE_SUCCESS_TEXT: 'Thanks for signing up!',
  SUBSCRIBE_FAIL: 'Your action was unsuccessful, please try again later.',
  LENGTH_EXCEEDS_LIMIT: 'Email address cannot exceed 255 characters.',
  EMAIL_INVALID: 'Email address is not valid.',
  REQUIRE_EMAIL: 'Email address must be specified.'
};



// WEBPACK FOOTER //
// ./app/constants/MemberFormDefaultMessage.js